/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

import { Box, CircularProgress } from '@mui/material';

import { LinkExpired } from '../../components/LinkExpired/LinkExpired';
import { LinkSuccessful } from '../../components/LinkSuccessful/LinkSuccessful';
import { Namespaces } from '../../i18n';
import { AuthenticationApiService } from '../../services/AuthenticationApiService';
import { ApiClientError } from '../../types/api/ApiClientError';
import { createEmailVerificationPageStyles } from './EmailVerificationPage.styles';
import { PathParamsType } from './EmailVerificationPage.types';

export const EmailVerificationPage = memo(() => {
  const classes = createEmailVerificationPageStyles();
  const params = useParams<PathParamsType>();
  const { t } = useTranslation(Namespaces.Login);
  const [isConfirmed, setIsConfirmed] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const { token } = params;
    if (token) {
      const fetchData = async () => {
        try {
          await AuthenticationApiService.verify(token);
          setIsConfirmed(true);
        } catch (e) {
          const error = e as ApiClientError;
          console.error(error);
          setIsConfirmed(false);
        }
      };
      void fetchData();
    }
  }, [params]);

  return (
    <Box className={classes.content}>
      {isConfirmed === undefined ? (
        <CircularProgress color="primary" size={60} />
      ) : isConfirmed ? (
        <LinkSuccessful />
      ) : !isConfirmed ? (
        <LinkExpired subTitle={t('page.link_expired.sub_title')} />
      ) : null}
    </Box>
  );
});
